
import { IconButton } from "@mui/material";
import WindowService from "../../services/windowService";
import VisibilityIcon from "@mui/icons-material/Visibility";

/**
 * Button component that opens the client passport dialog
 */
export const ChannelPassportButton = ({ channelId, size, color = "primary" }) => {
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        WindowService.openInNewTab(`/marketing-panel/channel-window/${channelId}/`)
    };

    return (
        <IconButton color={color} onClick={handleClick} size={size}>
            <VisibilityIcon />
        </IconButton>
    );
};
